import CustomViewDialogStore from "csi/middleware/customView/CustomViewDialogStore";
import { ICustomViewTableDropDownOptions } from "csi/middleware/customView/options/CustomViewOptions";
import DataSheetTableOptionsStore from "csi/middleware/customView/options/DataSheetTableOptionsStore";
import { action, makeObservable } from "mobx";
import { FunctionComponent, SyntheticEvent } from "react";
import { ICustomViewBOMOptions } from "../CustomViewBOMOptions";

/**
 * This store contains information about BOM options
 */
class BOMCustomViewOptionsStore extends DataSheetTableOptionsStore<ICustomViewBOMOptions> {
	constructor(
		tableDropDownOptions: ICustomViewTableDropDownOptions,
		component: FunctionComponent,
		customViewDialogStore: CustomViewDialogStore,
		options?: ICustomViewBOMOptions,
	) {
		super(tableDropDownOptions, component, customViewDialogStore, options);
		makeObservable(this);
	}

	/** set the value for compareToTheme */
	@action setCompareToTheme = (event: SyntheticEvent, value: boolean): void => {
		this.options.compareToTheme = value;
	};

	/** set the value for displayColorImages */
	@action setDisplayColorImages = (event: SyntheticEvent, value: boolean): void => {
		this.options.displayColorImages = value;
	};

	/** set the value for displaySupplierCodes */
	@action setDisplaySupplierCodes = (event: SyntheticEvent, value: boolean): void => {
		this.options.displaySupplierCodes = value;
	};
}

export = BOMCustomViewOptionsStore;